<div class="change-password-popup">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Change Password</h4>
    <div class="d-flex justify-content-end ms-auto">
      <button type="button" class="btn col-auto me-2 btn-secondary" (click)="modal.dismiss('Cross click')"><i class="fa fa-times"></i> Cancel</button>
      <button type="button" class="btn col-auto btn-primary"  (click)="formSubmit(changePasswordForm.value)"
          [disabled]="changePasswordForm.invalid || isLoader"> <i class="fa fa-save"></i> Save</button>
    </div>
  </div>

  <div class="modal-body">
    <div class="alert alert-danger" role="alert" *ngIf="responseErrors">
      <ul class="mb-0">
        <li *ngFor="let error of responseErrors">{{ error.message }}</li>
      </ul>
    </div>
    <form name="changePasswordForm" [formGroup]="changePasswordForm" novalidate>
      <div class="form-group">
        <div class="custom-input-box">
          <input
            type="password"
            class="form-control"
            placeholder="Old Password"
            formControlName="oldPassword"
          />
        </div>
      </div>
      <div class="form-group">
        <div class="custom-input-box">
          <input
            type="password"
            class="form-control"
            placeholder="New Password"
            formControlName="newPassword"
          />
        </div>
      </div>
      <div class="form-group">
        <div class="custom-input-box">
          <input
            type="password"
            class="form-control"
            placeholder="Confirm Password"
            formControlName="confirmPassword"
          />
        </div>
        <span
          class="text-danger"
          *ngIf="
            changePasswordForm
              .get('confirmPassword')
              .hasError('passwordsNotMatching')
          "
        >
          Passwords must match
        </span>
      </div>
     
    </form>
  </div>
</div>
